import React from 'react'
import translations from './translations'

translations.add('is', {
    paymentTimedOut: 'Greiðslan þín hefur runnið út á tíma. Vinsamlegast reyndu aftur.',
    close: 'Loka'
})
